import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Box, CircularProgress, Typography } from '@mui/material';

export const AuthCallback: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Once authentication is complete, redirect to home
    if (!auth.isLoading && auth.isAuthenticated) {
      navigate('/');
    }

    // If there's an error, log it
    if (auth.error) {
      console.error('Authentication error:', auth.error);
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Completing authentication...
      </Typography>
    </Box>
  );
};
